import { Card, CardBody, CardHeader, Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap'
import { getProperties, getMeters, getUtilities, getPropertyUtilities, getPropertyUtilityMeters } from '../../Services/ClientService';
import { FormEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import { Href } from '../../Utils/Constants';
import Table from '../../CustomComponent/Tables/Table';
import { TableColumn } from 'react-data-table-component';
import { MoreVertical, Eye, Pencil, Unlock, Lock, Plus, Trash2, ChartLine } from 'lucide-react';
import { Btn, H4, P } from '../../AbstractElements';
import Modal from '../../CustomComponent/Modals/Modal';
import SelectDropdown from '../../CustomComponent/Form/SelectDropdown';
import { useNavigate, useParams } from 'react-router-dom';
import { useApp } from '../../Contexts/AppContext';
import { BarChart, ChartColumnIncreasing } from 'lucide-react';
import { getTrackerChart } from '../../Services/ClientService';
import ColumnChart from '../../CustomComponent/Charts/ColumnChart';
import EnergyColumnChart from '../../CustomComponent/Charts/EnergyColumnChart';
import EnergyLineChart from '../../CustomComponent/Charts/EnergyLineChart';
import { sortByKey } from '../../Utils';

export const justifyTabNav = [{ id: 'chart', nav: 'Energy Charts' }, { id: 'report', nav: 'Energy Report' }, { id: 'add', nav: 'Add Data' }];
type billParams = {
    company_id: string,
    property_id?: string,
    utility_id?: string,
    year?: string
}

type trackerParams = {
    client_id: string,
    property_id?: string,
    utility_id?: string,
    site_id?: string,
    meters?: string[],
    checkType: string,
    typeMode: string,
    year?: string
    month?: string,
    day?: string,
    date?: string,
    start_date?: string,
    end_date?: string
}

export interface BillTableRow {
    property?: { name?: string };
    bill_date: string;
    bill_type: string;
    start_date: string;
    end_date: string;
    utility?: { name?: string; si_unit?: string };
    supplier?: { name?: string };
    total_consumption: number | string;
    cost: number | string;
    currency?: { major_symbol?: string };
}

export default function EnergyTracker() {
    const navigate = useNavigate();
    const [selectedClient, setSelectedClient] = useState('');
    const [properties, setProperties] = useState<any>([]);
    const [utilities, setUtilities] = useState<any>([]);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [selectedUtility, setSelectedUtility] = useState('');
    const [utility, setUtility] = useState('');
    const [trackerData, setTrackerData] = useState<any>(null);
    const [meters, setMeters] = useState<any>([]);
    const [selectedMeter, setSelectedMeter] = useState('');
    const [selectedMeters, setSelectedMeters] = useState<string[]>([]);
    const [basicTab, setBasicTab] = useState('chart');
    const [activeChart, setActiveChart] = useState('bar');
    const [activeMode, setActiveMode] = useState('Single');
    const [value, setValue] = useState(2)
    const [timeMode, setTimeMode] = useState('year');
    const [selectedYear, setSelectedYear] = useState<number>();
    const [selectedMonth, setSelectedMonth] = useState<number>();
    const [selectedDay, setSelectedDay] = useState<number>();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        const storedClient = localStorage.getItem('selectedClient');
        if (storedClient) {
            setSelectedClient(storedClient);
        }
    }, []);

    useEffect(() => {
        if (!selectedClient) return;
        fetchProperties()
        localStorage.setItem('selectedClient', selectedClient)
    }, [selectedClient]);

    useEffect(() => {
        if (!selectedProperty) return;
        fetchPropertyUtilities();
        // localStorage.setItem('selectedClient', selectedClient)
    }, [selectedProperty]);

    useEffect(() => {
        if (!selectedUtility) return;
        fetchUtilityMeters()
        // localStorage.setItem('selectedClient', selectedClient)
    }, [selectedUtility]);

    const fetchProperties = async () => {
        try {
            const { properties } = await getProperties();
            // Cast properties to an array of objects with a 'name' key so sortByKey type is satisfied
            setProperties(sortByKey(properties as { name: string }[], 'name'));
        } catch (error: any) {
            toast.error(error?.message || 'Failed to fetch Properties');
        }
    }

    const fetchPropertyUtilities = async () => {
        try {
            const data: any[] = await getPropertyUtilities(selectedProperty);
            setUtilities(sortByKey(data, 'name'));
        } catch (error: any) {
            toast.error(error?.message || 'Failed to fetch Properties');
        }
    };

    const fetchUtilityMeters = async () => {
        try {
            const data: any[] = await getPropertyUtilityMeters(selectedProperty, selectedUtility);
            setMeters(sortByKey(data, 'name'));
        } catch (error: any) {
            toast.error(error?.message || 'Failed to fetch Properties');
        }
    };

    const propertyOptions = properties.map((property: { property_id: string; name: string }) => ({
        value: property.property_id, // Assuming property_id is the unique identifier
        label: property.name // Assuming property_name is the display name
    }));

    const utilityOptions = utilities.map((utility: { utility_id: string; name: string }) => ({
        value: utility.utility_id, // Assuming property_id is the unique identifier
        label: utility.name // Assuming property_name is the display name
    }));

    const meterOptions = meters.map((meter: { site_id: string; name: string }) => ({
        value: meter.site_id, // Assuming property_id is the unique identifier
        label: meter.name // Assuming property_name is the display name
    }));

    const handlePropertyChange = (selectedValue: any) => {
        setSelectedProperty(selectedValue as string);
        // localStorage.setItem('selectedProperty', selectedValue as string);
    };

    const handleUtilityChange = (selectedValue: any) => {
        setSelectedUtility(selectedValue as string);
        // localStorage.setItem('selectedProperty', selectedValue as string);
    };

    // const fetchBills = async ({ company_id, property_id, utility_id, year }: billParams) => {
    //     if (company_id == '') return
    //     const billData = await getBills({ company_id });
    //     setBills(billData);
    // }

    // const fetchMeters = async (clientId: string) => {
    //     if (clientId == '') return
    //     const meterData = await getMeters(clientId);
    //     setMeters(meterData);
    // }

    const ActionDropdown = ({ row }: { row: any }) => {
        const [dropdownOpen, setDropdownOpen] = useState(false);
        const toggle = () => setDropdownOpen(prevState => !prevState);

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                <DropdownToggle color="transparent" className="p-0 border-0 shadow-none">
                    <MoreVertical size={18} />
                </DropdownToggle>
                <DropdownMenu end>
                    <DropdownItem onClick={() => navigate(`${process.env.PUBLIC_URL}/clients/${row.bill_id}`)}>
                        <Eye size={16} color="green" className="me-2" />
                        View
                    </DropdownItem>

                    <DropdownItem onClick={() => console.log('Edit', row)}>
                        <Pencil size={16} color="orange" className="me-2" />
                        Edit
                    </DropdownItem>
                    {/* <DropdownItem onClick={() => console.log('Delete', row)}>
                        <Trash2 size={16} color="red" className="me-2" />
                        Delete
                    </DropdownItem> */}
                </DropdownMenu>
            </Dropdown>
        );
    };

    const meterTableColumns: TableColumn<any>[] = [
        {
            name: "Property",
            cell: (row) => row.property.name,
            sortable: false,
            center: false,
        },
        {
            name: "Meter Name",
            selector: (row) => row.name,
            sortable: false,
            center: false,
        },
        {
            name: "Type",
            selector: (row) => row.meter_type,
            sortable: true,
            center: false,
            // color: 'orange'
        },
        {
            name: "Meter No.",
            selector: (row) => `${row.meter_no_1 || ''}${row.meter_no_2 || ''}`,
            sortable: true,
            center: false,
            // color: 'orange'
        },
        {
            name: "Utility",
            cell: (row) => row.utility?.name || '',
            sortable: false,
            center: false,
        },
        {
            name: "S.I. Unit",
            cell: (row) => row.utility?.si_unit || '',
            sortable: false,
            center: true,
        },
        {
            name: 'Actions',
            cell: (row) => <ActionDropdown row={row} />,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '70px',
        },
    ];

    const updateValue = (increment: any) => {
        setValue((prevValue) => Math.max(2, Math.min(prevValue + increment, 6)));
    };

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Get current month (1-12)
    const currentDay = currentDate.getDate();

    const months = Array.from({ length: 12 }, (_, i) => i + 1).map((month) => {
        const isDisabled = selectedYear === currentYear && month > currentMonth; // Disable future months in the current year
        const isUsedUp = selectedYear === currentYear && month > currentMonth; // Check if the month is used up for the current year

        return (
            <Col md="3" className={`border p-1 ${selectedMonth === month ? "bg-primary" : ""} ${!isDisabled ? 'cursor-pointer' : ''} ${selectedYear ? "" : "disabled"}`}
                // onClick={() => selectedYear && setSelectedMonth(month)} // Only set selectedMonth if selectedYear is defined
                onClick={() => {
                    if (!isDisabled && selectedYear) {
                        setSelectedMonth(month);
                        setSelectedDay(undefined);
                    }
                }} // Only set selectedMonth if not disabled
                style={{
                    fontSize: '0.8rem',
                    backgroundColor: isUsedUp ? '#ccc' : '' // Set background color for used up months
                }}
            >
                {new Date(0, month - 1).toLocaleString('default', { month: 'short' })}
            </Col>
        );
    });

    const daysInSelectedMonth = selectedYear && selectedMonth ? new Date(selectedYear, selectedMonth, 0).getDate() : 31;
    const dayCells = Array.from({ length: daysInSelectedMonth }, (_, i) => i + 1).map((day) => {
        const isFutureDay = selectedYear === currentYear && selectedMonth === currentMonth && day >= currentDay;
        const isDisabled = !selectedYear || !selectedMonth || isFutureDay;

        return (
            <div
                key={day}
                className={`border p-1 text-center ${selectedDay === day ? "bg-primary text-white" : ""} ${!isDisabled ? 'cursor-pointer' : 'disabled'}`}
                onClick={() => !isDisabled && setSelectedDay(day)}
                style={{
                    fontSize: '0.75rem',
                    // borderRadius: '4px',
                    backgroundColor: isDisabled ? '#f8f9fa' : undefined,
                    color: isDisabled && selectedDay !== day ? '#a0a0a0' : undefined,
                }}
            >
                {day}
            </div>
        );
    });

    const days = (
        <div
            className="d-grid"
            style={{
                gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                //     gap: '0.35rem',
            }}
        >
            {dayCells}
        </div>
    );

    const getData = async (e: FormEvent) => {
        e.preventDefault()

        try {
            const params: trackerParams = {
                site_id: selectedMeter,
                client_id: selectedClient,
                property_id: selectedProperty,
                utility_id: selectedUtility,
                year: selectedYear?.toString(),
                month: selectedMonth?.toString(),
                day: timeMode === 'Daily' ? selectedDay?.toString() : undefined,
                date: selectedYear && selectedMonth && (timeMode === 'Daily' && selectedDay)
                    ? `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(selectedDay).padStart(2, '0')}`
                    : selectedYear && selectedMonth
                        ? `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`
                        : selectedYear
                            ? `${selectedYear}`
                            : undefined,
                typeMode: activeMode,
                checkType: timeMode,
                start_date: startDate,
                end_date: endDate
            };

            const { site_id, date, data, meter } = await getTrackerChart(params);

            let formattedData = {}
            switch (timeMode) {
                case 'Multiyear':
                    formattedData = {
                        categories: data.map((item: { year: number }) => item.year.toString()),
                        // series: data.map((item: { energy_value: number; year: number }) => ({
                        //     name: item.year.toString(),
                        //     data: item.energy_value
                        // })),
                        series: [{
                            name: utility,
                            data: data.map((item: { energy_value: number; year: string }) => item.energy_value)
                        }],
                        si_unit: utility === 'Electricity' ? 'kWh' : utility === 'Gas' ? 'Es' : utility === 'Water' ? 'CuM2' : '',
                    };
                    break;
                case 'Year':
                    formattedData = {
                        categories: data.map((item: { month: string }) => item.month),
                        series: [{
                            name: utility,
                            data: data.map((item: { energy_value: number; month: string }) => item.energy_value)
                        }],
                        // series: data.map((item: { energy_value: number; month: string }) => ({
                        //     name: item.month,
                        //     data: item.energy_value
                        // })),
                        si_unit: utility === 'Electricity' ? 'kWh' : utility === 'Gas' ? 'Es' : utility === 'Water' ? 'CuM2' : '',
                    };
                    break;
                case 'Monthly':
                    formattedData = {
                        categories: data.map((item: { day: string }) => item.day),
                        series: [{
                            name: 'Energy Consumption',
                            data: data.map((item: { energy_value: number }) => item.energy_value)
                        }],
                        si_unit: utility === 'Electricity' ? 'kWh' : utility === 'Gas' ? 'Es' : utility === 'Water' ? 'CuM2' : '',
                    };
                    break;
                case 'Daily':
                    formattedData = {
                        categories: data.map((item: { time: number }) => item.time),
                        series: [{
                            name: 'Energy Consumption',
                            data: data.map((item: { energy_value: number }) => item.energy_value)
                        }],
                        si_unit: utility === 'Electricity' ? 'kWh' : utility === 'Gas' ? 'Es' : utility === 'Water' ? 'CuM2' : '',
                    };
                    break;
                case 'From/To':
                    formattedData = {
                        categories: data.map((item: { day: string }) => item.day),
                        series: [{
                            name: 'Energy Consumption',
                            data: data.map((item: { energy_value: number }) => item.energy_value)
                        }],
                        si_unit: utility === 'Electricity' ? 'kWh' : utility === 'Gas' ? 'Es' : utility === 'Water' ? 'CuM2' : '',
                    };
                    break;
                default:
                    console.log('Unknown time mode');
            }

            setTrackerData(formattedData)

            // Fetch meters data if selectedUtility is defined
            // if (selectedUtility) {
            //     const metersData = await getPropertyUtilityMeters(selectedClient, selectedProperty, selectedUtility);
            //     setMeters(metersData);
            // }
        } catch (error: any) {
            toast.error(error?.message || 'Failed to fetch data');
        }
    };

    // useEffect(() => {
    //     fetchData();
    // }, [selectedClient, selectedProperty, selectedUtility, selectedYear]);


    return (
        <>
            <Row>
                <Col md="8" className=''>
                    <Breadcrumbs pageTitle='Energy Tracker' />
                </Col>
            </Row>

            <Container className='default-dashboard' fluid>
                <Row style={{ textAlign: 'center' }}>
                    <Col md={basicTab === 'add' ? 12 : 9}>
                        <Card>
                            {/* <CommonCardHeader title={JustifyTabTitle} subTitle={justifyTabSubTitle} /> */}
                            <CardBody>
                                <CardHeader className='d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2 p-0'>
                                    <Nav className='nav-primary' pills>
                                        {justifyTabNav.map((item) => (
                                            <NavItem>
                                                <NavLink href={Href} className={`${basicTab === item.id ? 'active' : ''}`} onClick={() => setBasicTab(item.id)}>{item.nav}</NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>
                                </CardHeader>
                                <CardBody className='px-0 pb-0'>
                                    <TabContent activeTab={basicTab}>
                                        <TabPane tabId='chart'>
                                            <Row className="justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                                                <Col lg="12" className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                                                    {/* <CardBody style={{ width: '100%', minHeight: '20vh', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0 }}> */}
                                                    {trackerData && activeChart === 'bar' && (
                                                        <EnergyColumnChart title='Chart' data={trackerData} height={window.innerHeight * 0.64} width={window.innerWidth * 0.54} size={12} />
                                                    )}
                                                    {trackerData && activeChart === 'line' && (
                                                        <EnergyLineChart title='Chart' data={trackerData} height={window.innerHeight * 0.64} width={window.innerWidth * 0.54} size={12} />
                                                    )}
                                                    {/* </CardBody> */}
                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId='report'>
                                            {/* <Table title='' tableColumns={meterTableColumns} data={meters} /> */}
                                        </TabPane>
                                    </TabContent>
                                </CardBody>
                            </CardBody>
                        </Card>
                    </Col>
                    {basicTab !== 'add' &&
                        <Col md="3">
                            <Card>
                                <CardBody>

                                    <Form className="theme-form" onSubmit={getData}>
                                        <H4 className='text-center'>Filter</H4>
                                        <Row className='text-start'>
                                            <Col md='12'>
                                                <Row className='text-center align-center pl-2'>
                                                    <Col className={`border ${activeChart === 'bar' ? 'bg-primary' : ''} cursor-pointer`} onClick={() => setActiveChart('bar')}>
                                                        <ChartColumnIncreasing />
                                                    </Col>
                                                    <Col className={`border ${activeChart === 'line' ? 'bg-primary' : ''} cursor-pointer`} onClick={() => setActiveChart('line')}>
                                                        <ChartLine />
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col className='mt-2' md='12'>
                                                <FormGroup>
                                                    <SelectDropdown title={'Properties'} placeholder='Property' options={propertyOptions} value={selectedProperty} onOptionSelected={(val) => handlePropertyChange(val)} />
                                                    <div className="alert alert-danger" id="company_mess_div" hidden>
                                                        <p id="company_message"></p>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col className='mt-2' md='12'>
                                                <FormGroup>
                                                    <SelectDropdown title={'Utilities'} placeholder='Utility' options={utilityOptions} value={selectedUtility} onOptionSelected={(val) => { handleUtilityChange(val); }} onOptionTextSelected={(val) => { setUtility(String(val)) }} />
                                                    <div className="alert alert-danger" id="company_mess_div" hidden>
                                                        <p id="company_message"></p>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col className='mt-2' md='12'>
                                                <FormGroup>
                                                    <SelectDropdown title={'Meters'} placeholder='Meter' options={meterOptions} value={selectedMeter} onOptionSelected={(val) => setSelectedMeter(val as string)} />
                                                    <div className="alert alert-danger" id="company_mess_div" hidden>
                                                        <p id="company_message"></p>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            {/* <Col className='mt-2' md='12'>
                                                <Row className='text-center align-center pl-2'>
                                                    <Col className={`border py-1 ${activeMode === 'Single' ? 'bg-primary' : ''} cursor-pointer`} onClick={() => setActiveMode('Single')}>
                                                        Single
                                                    </Col>
                                                    <Col className={`border py-1 ${activeMode === 'Compare' ? 'bg-primary' : ''} cursor-pointer`} onClick={() => setActiveMode('Compare')}>
                                                        Compare
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {activeMode === 'Single' &&
                                                <Col className='mt-2' md='12'>
                                                    <FormGroup>
                                                        <SelectDropdown title={'Meters'} placeholder='Meter' options={meterOptions} value={selectedMeter} onOptionSelected={(val) => setSelectedMeter(val as string)} />
                                                        <div className="alert alert-danger" id="company_mess_div" hidden>
                                                            <p id="company_message"></p>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            }
                                            {activeMode === 'Compare' &&
                                                <>
                                                    <Col className='mt-2' md='12'>
                                                        <FormGroup>
                                                            <Col><Label>Compare Factor</Label></Col>

                                                            <Row className='d-flex align-items-center justify-content-between'>
                                                                <Col md='2' className="text-center">
                                                                    <Btn color="primary" id="decrement" onClick={() => updateValue(-1)} style={{ backgroundColor: '#B0B0B0' }}>-</Btn>
                                                                </Col>
                                                                <Col md='4' className="text-center">
                                                                    <p id="compare_value" className="increment-decrement-input">{value}</p>
                                                                </Col>
                                                                <Col md='2' className="text-center">
                                                                    <Btn color="primary" id="increment" onClick={() => updateValue(1)}>+</Btn>
                                                                </Col>
                                                            </Row>
                                                            <div className="alert alert-danger" id="meter-name_mess_div" hidden>
                                                                <p id="meter-name_message"></p>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col className='mt-2' md='12'>
                                                        <Row>
                                                            {[...Array(value)].map((_, index) => (
                                                                <Col key={index} md={6}>
                                                                    <FormGroup>
                                                                        <SelectDropdown title={`Meter ${index + 1}`} placeholder='Meter' options={meterOptions} value={selectedMeter} onOptionSelected={(val) => {
                                                                            const updated = [...selectedMeters];
                                                                            updated[index] = val as string;
                                                                            setSelectedMeters(updated);
                                                                        }} />
                                                                        <div className="alert alert-danger" id={`company_mess_div_${index}`} hidden>
                                                                            <p id={`company_message_${index}`}></p>
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Col>
                                                </>
                                            } */}

                                            <Col md='12'>
                                                <FormGroup>
                                                    <Label>Mode Selection</Label>
                                                    <Row className='text-center'>
                                                        <Col md="6" className={`border py-1 ${timeMode === "Multiyear" ? "bg-primary" : ""} cursor-pointer`} onClick={() => setTimeMode("Multiyear")}>Multiyear</Col>
                                                        <Col md="6" className={`border py-1 ${timeMode === "Year" ? "bg-primary" : ""} cursor-pointer`} onClick={() => setTimeMode("Year")}>Year</Col>
                                                    </Row>
                                                    <Row className='text-center'>
                                                        <Col md="6" className={`border py-1 ${timeMode === "Monthly" ? "bg-primary" : ""} cursor-pointer`} onClick={() => setTimeMode("Monthly")}>Monthly</Col>
                                                        <Col md="6" className={`border py-1 ${timeMode === "Weekly" ? "bg-primary" : ""} cursor-pointer`} onClick={() => setTimeMode("Weekly")}>Weekly</Col>
                                                    </Row>
                                                    <Row className='text-center'>
                                                        <Col md="6" className={`border py-1 ${timeMode === "Daily" ? "bg-primary" : ""} cursor-pointer`} onClick={() => setTimeMode("Daily")}>Daily</Col>
                                                        <Col md="6" className={`border py-1 ${timeMode === "From/To" ? "bg-primary" : ""} cursor-pointer`} onClick={() => setTimeMode("From/To")}>From/To</Col>
                                                    </Row>
                                                    <div className="alert alert-danger" id="mode_mess_div" hidden>
                                                        <p id="mode_message"></p>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            {(timeMode === 'Year' || timeMode === 'Monthly' || timeMode === 'Daily') &&
                                                <Col md='12'>
                                                    <FormGroup>
                                                        <Row className='justify-content-center text-center'>
                                                            {Array.from({ length: new Date().getFullYear() - 2019 }, (_, i) => 2020 + i).map((year) => (
                                                                <Col md="3" className={`border py-1 m-1 ${selectedYear === year ? "bg-primary" : ""} cursor-pointer`} style={{ fontSize: '0.6rem' }} onClick={() => { setSelectedYear(year); setSelectedMonth(undefined); setSelectedDay(undefined); }}>{year}</Col>
                                                            ))}
                                                        </Row>
                                                    </FormGroup>
                                                </Col>
                                            }
                                            {(timeMode === 'Monthly' || timeMode === 'Daily') &&
                                                <Col md='12'>
                                                    <FormGroup>
                                                        <Row className='justify-content-center text-center'>
                                                            {months}
                                                        </Row>
                                                    </FormGroup>
                                                </Col>
                                            }
                                            {timeMode === 'Daily' &&
                                                <Col md='12'>
                                                    <FormGroup>
                                                        {/* <Label>Days (7 per row)</Label> */}
                                                        {days}
                                                    </FormGroup>
                                                </Col>
                                            }
                                            {timeMode === 'From/To' &&
                                                <Row>
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label>From</Label>
                                                            <Input
                                                                type="date"
                                                                value={startDate || ''}
                                                                onChange={e => {
                                                                    setStartDate(e.target.value);
                                                                    // Optionally, validate date range here
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label>To</Label>
                                                            <Input
                                                                type="date"
                                                                value={endDate || ''}
                                                                onChange={e => {
                                                                    setEndDate(e.target.value);
                                                                    // Optionally, validate date range here
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            }
                                        </Row>
                                        <Row className='justify-content-center'>
                                            <Col md="12">
                                                <Btn className='w-full' color="primary" type="submit">Get Report</Btn>
                                            </Col>
                                        </Row>
                                    </Form>

                                </CardBody>
                            </Card>
                        </Col>
                    }
                </Row>
                {/* {client && (
                    <Row className="mb-4">
                        <Col sm="12">
                            <div className="p-4 border border-primary rounded shadow-sm">
                                <Row className="gy-3">
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Company Name</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Email Address</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client.email_address}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Country</small>
                                            <div className="text-primary fw-bold">{client.country?.name}</div>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">No. of Properties</small>
                                            <div className="text-primary fw-bold">{properties.length}</div>
                                        </div>
                                    </Col>
                                    <Col lg="8" md="12">
                                        <div>
                                            <small className="text-muted text-uppercase fw-semibold">Address</small>
                                            <div className="text-primary fw-bold" style={{ wordBreak: 'break-word' }}>{client.address}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )} */}

                <Row>
                    {/* <Col sm="12" className="d-flex justify-content-end">
                        <Btn color='primary' className="mb-3" onClick={togglePropertyModal}>Add Property</Btn>
                    </Col> */}

                    {/* <Table title='Properties' tableColumns={tableColumns} data={properties} /> */}
                </Row>
            </Container >
        </>
    );
}